import { WSAlert } from "@wingspanhq/fe-component-library";
import React, { useMemo } from "react";
import { queriesExternalBankAccounts } from "@query";
import { selectorExternalBankAccountVerificationPending } from "@selectors/selectorExternalBankAccountVerificationPending";
import { useModalMicrodepositsVerify } from "./ModalMicrodepositsVerify";
import { selectorExternalBankAccountLabel } from "../selectors/selectorExternalBankAccountLabel";

export const AlertPendingAccountMicroDeposit: React.FC = () => {
  const queryExternalBankAccounts =
    queriesExternalBankAccounts.listExternalBankAccounts.useQuery();

  const pendingExternalBankAccount = useMemo(
    () =>
      (queryExternalBankAccounts.data?.data || []).find(
        selectorExternalBankAccountVerificationPending
      ),
    [queryExternalBankAccounts.data]
  );

  const modalMicrodepositsVerify = useModalMicrodepositsVerify();

  if (!pendingExternalBankAccount) {
    return null;
  }

  return (
    <WSAlert
      theme="warning"
      icon="alert"
      title="Action required"
      action={{
        text: "Verify",
        onClick: () => {
          modalMicrodepositsVerify.open({
            externalBankAccount: pendingExternalBankAccount
          });
        }
      }}
    >
      Wingspan sent micro-deposits to{" "}
      {selectorExternalBankAccountLabel(pendingExternalBankAccount)}. Enter the
      amounts deposited to verify your account.
    </WSAlert>
  );
};
